<template>
    <div>
        <SidePanel
            :visible="!!(pattyStore && pattyStore?.isPanelVisible)"
            title="Ask Patty"
            :no-scroll="!pattyStore || pattyStore.activeTab === 'THREAD'"
            :body-style="
                pattyStore &&
                pattyStore.activeTab === 'NEW' &&
                this.$windowHeight > 772
                    ? 'overflow: visible'
                    : ''
            "
            @close="closePanel"
        >
            <PattyThreadList
                v-if="pattyStore.activeTab === 'HISTORY'"
                :all-threads="threads"
            />

            <PattyThread
                ref="askPattyTab"
                v-else-if="pattyStore.activeTab === 'THREAD'"
                :thread-id="activeThreadId"
            />

            <NewChat
                v-else-if="pattyStore.activeTab === 'NEW'"
                :show-history-btn="false"
            />

            <template #footer>
                <!-- Alpha Access Footer -->
                <div v-if="$userStore.companyHasPerm('alpha:access')">
                    <PanelFooter
                        :show-choose-guardian="true"
                        @choose-guardian="handleChooseGuardian"
                        @open-history="pattyStore.openHistory()"
                    />
                </div>

                <!-- Original Footer (Non-Alpha) -->
                <div v-else>
                    <hr />

                    <div class="footer-row">
                        <button
                            v-if="
                                pattyStore.activeTab === 'NEW' ||
                                pattyStore.activeTab === 'THREAD'
                            "
                            class="btn btn-light"
                            type="button"
                            @click="pattyStore.openHistory()"
                        >
                            History
                        </button>

                        <button
                            v-if="
                                pattyStore.activeTab === 'HISTORY' ||
                                pattyStore.activeTab === 'THREAD'
                            "
                            class="btn btn-primary"
                            type="button"
                            @click="pattyStore.openNew()"
                        >
                            New Chat
                        </button>
                    </div>
                </div>
            </template>
        </SidePanel>

        <!-- Modal outside SidePanel so it's not affected by panel visibility -->
        <GuardianSelectionModal
            v-if="$userStore.companyHasPerm('alpha:access')"
            :visible="isGuardianModalVisible"
            @close="closeGuardianModal"
        />
    </div>
</template>

<script>
import PattyThread from '@/components/patty/PattyThread.vue';
import NewChat from '@/components/patty/NewPattyChat.vue';
import PattyThreadList from '@/components/patty/PattyThreadList.vue';
import GuardianSelectionModal from '@/components/guardians/GuardianSelectionModal.vue';
import SidePanel from '@/components/SidePanel.vue';
import PanelFooter from '@/components/PanelFooter.vue';
//import Paginator from '@/components/Paginator.vue';
//import Field from '@/components/Field.vue';
import {
    getTransactions,
    getTransaction,
    sendMessage,
    deleteThread,
} from '@/components/patty/PattyService';

import { usePattyStore } from '@/stores/patty';
import { useAdminStore } from '@/stores/admin';

export default {
    name: 'PattyPanel',
    components: {
        PattyThread,
        //Field,
        NewChat,
        PattyThreadList,
        GuardianSelectionModal,
        SidePanel,
        PanelFooter,
        //Paginator,
    },
    props: {
        newChatResponse: {
            type: Object,
            required: false,
            default: null,
        },
        visible: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            pattyStore: null,

            threads: [],
            activeThreadId: -1,

            originalCompanyID: null,
            adminStore: null,
            isGuardianModalVisible: false,
        };
    },
    watch: {
        'pattyStore.isPanelVisible': {
            handler(isVisible) {
                if (!this.adminStore) return;

                if (isVisible && this.originalCompanyID === null) {
                    if (
                        this.adminStore.companyId !== null &&
                        this.adminStore.companyId !== undefined
                    ) {
                        this.originalCompanyID = this.adminStore.companyId;
                        this.adminStore.setCompanyId(null);
                    }
                } else if (!isVisible && this.originalCompanyID !== null) {
                    this.adminStore.setCompanyId(this.originalCompanyID);
                    this.originalCompanyID = null;
                }
            },
        },
    },
    computed: {
        /** Number of threads to display per page */
        recordsPerPage() {
            return this.$isMobile
                ? Math.floor(this.returnAvailableHeight() / 75)
                : Math.floor(this.returnAvailableHeight() / 116);
        },

        /** Calculate maximum number of pages based on total threads */
        maxPages() {
            const maxPages = Math.ceil(this.totalThreads / this.recordsPerPage);
            return maxPages > 0 ? maxPages : 1;
        },
    },

    methods: {
        tabChange(newValue) {
            if (newValue === 'HISTORY') this.pattyStore.openHistory();
            else if (newValue == 'THREAD') this.pattyStore.openThread();
            else if (newValue == 'NEW') this.pattyStore.openNew();
        },

        closePanel() {
            this.pattyStore.closePanel();
        },

        handleChooseGuardian() {
            // Show guardian selection modal
            this.isGuardianModalVisible = true;
        },

        closeGuardianModal() {
            this.isGuardianModalVisible = false;
        },
    },
    mounted() {
        this.pattyStore = usePattyStore();
        this.adminStore = useAdminStore();
    },
    beforeUnmount() {
        if (this.adminStore && this.originalCompanyID !== null) {
            this.adminStore.setCompanyId(this.originalCompanyID);
        }
    },
};
</script>

<style scoped>
hr {
    margin-bottom: var(--space-3);
}

.footer-row {
    display: flex;
    justify-content: end;
    gap: var(--space-3);
}
</style>
